import { BaseClient } from 'src/common-services/clients/base-client'
import { TrendsDatum } from 'src/common-services/types/footfall-types'

export class OlvinClient extends BaseClient {
  trends(placekey: string, start: string, end: string) {
    const path = `/olvin/trends/${placekey}`
    return this.get<TrendsDatum[] | undefined>(path, { start, end })
  }
}
